<template>
  <div class="statistics-page">
    <div class="header">易尤特电子工牌系统后台</div>
    <div class="statistics-content">
      <el-tabs class="tabs-container" v-model="activeName" stretch tab-position="left" @tab-click="handleClick">
        <el-tab-pane label="后台管理" name="first">
          <Management :state="state" :starList="starList" />
        </el-tab-pane>
        <el-tab-pane label="扫码统计" name="second">
          <CodeStatistcs :stateValue="stateValue" :starList="starList" />
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import Management from './components/Management.vue'
import CodeStatistcs from './components/CodeStatistcs.vue'
export default {
  name: 'electronicStatistics',
  components: {
    Management,
    CodeStatistcs
  },
  data() { 
    return {
      activeName: 'first',
      state: false,
      stateValue: 0,
      starList: [
        { text: '5星', value: 5 },
        { text: '4星', value: 4 },
        { text: '3星', value: 3 },
        { text: '2星', value: 2 },
        { text: '1星', value: 1 },
        { text: '未评分', value: 0 },
      ],
    }
  },
  created() { },
  methods: {
    handleClick(v) {
      if (v.index == 0) { 
        this.state = true
        this.stateValue = 0
      } else { 
        this.state = false
        this.stateValue = 1
      }
    }
  }
}
</script>
<style scoped>
.statistics-page{
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  overflow: hidden;
}
.header {
  width: 100%;
  height: 60px;
  line-height: 60px;
  background-color:#2f7fd2;
  text-align: left;
  padding: 0 20px;
  color: #fff;
}
.statistics-content {
  height: calc(100% - 60px);
}
.tabs-container {
  height: 100%;
}
.tabs-container /deep/.el-tabs__header {
  width: 140px;
  margin-right: 0;
  background-color: #3a8ee6;
}
.tabs-container /deep/ .el-tabs__item {
  text-align: center;
  color: #fff;
}
.tabs-container /deep/ .el-tabs__item:hover{
  background-color: #4794e3;
}
.tabs-container /deep/ .el-tabs__item.is-active {
  background-color: #2f7fd2;
}
.tabs-container /deep/ .el-tabs__content {
  height: 100%;
  box-sizing: border-box;
  padding: 15px;
  overflow-y: auto;
  overflow-x: hidden;
}
</style>